import React from 'react';
import { Link } from 'react-router-dom';
import gplayBadge from '../assetsNew/images/gplay.png';
import appstoreBadge from '../assetsNew/images/appstore.png';

const REDIRECT_URL = 'https://recruit.placerep.ai';
const MN_LOGO = `${process.env.PUBLIC_URL}/images/mp-logo.svg`;
const androidLink = 'https://play.google.com/store/apps/details?id=com.masternaukri.app&hl=en_IN';
const iosLink = 'https://apps.apple.com/in/app/masternaukri/id6450824258';

export default function RedirectFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="pr-footer">
      <div className="pr-footer-inner">
        {/* Brand + app badges */}
        <div className="pr-footer-col pr-footer-brand">
          <img src={MN_LOGO} alt="masterNAUKRI" className="pr-footer-logo" />
          <p className="pr-footer-tagline">
            A KidEx Venture Private Limited company.
          </p>
          <div className="pr-footer-apps" aria-label="Download the masterNAUKRI app">
            <a
              href={androidLink}
              target="_blank"
              rel="noreferrer"
              className="pr-footer-app-link"
              aria-label="Get it on Google Play"
            >
              <img src={gplayBadge} alt="Get it on Google Play" className="pr-footer-app-badge" />
            </a>
            <a
              href={iosLink}
              target="_blank"
              rel="noreferrer"
              className="pr-footer-app-link"
              aria-label="Download on the App Store"
            >
              <img src={appstoreBadge} alt="Download on the App Store" className="pr-footer-app-badge" />
            </a>
          </div>
        </div>

        {/* Navigation */}
        <div className="pr-footer-col">
          <h3 className="pr-footer-heading">Quick Links</h3>
          <ul className="pr-footer-links">
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-and-conditions">Terms &amp; Conditions</Link></li>
            <li><a href="mailto:info@kid-ex.com">Contact us</a></li>
          </ul>
        </div>

        {/* Visit PlaceRep CTA */}
        <div className="pr-footer-col pr-footer-cta-col">
          <h3 className="pr-footer-heading">Our new home</h3>
          <p className="pr-footer-cta-desc">
            Same team, smarter platform &mdash; pick up where you left off.
          </p>
          <a href={REDIRECT_URL} className="pr-footer-cta">
            Visit recruit.placerep.ai
            <span aria-hidden="true">&rarr;</span>
          </a>
        </div>
      </div>

      <div className="pr-footer-bottom">
        <div className="pr-footer-bottom-inner">
          <span className="pr-footer-copy">&copy; {year} masterNAUKRI.</span>
          <a href={REDIRECT_URL} className="pr-footer-bottom-link">recruit.placerep.ai</a>
        </div>
      </div>
    </footer>
  );
}
